module.exports = __webpack_public_path__ + "img/tavi_biel_kamera_ocular.1a055f50.jpg";